'use client';

import type { FC, ReactNode } from 'react';
import styles from './ContentWrapper.module.css';

const ContentWrapper: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className={`flex-col ${styles.wrapper}`}>{children}</div>
);

export default ContentWrapper;
